/**
 * P227 -- sparkline normalisation. Maps a metric series to y-fractions in
 * [0, 1] (1 = top of the band):
 *   - "pct": a 0-100 metric (availability / error rate) -> value / 100.
 *   - "max": an unbounded metric (latency ms) -> value / seriesMax, so the
 *     sparkline fills its band relative to its own peak.
 * An all-zero (or empty) series maps to all-zero fractions.
 */
export function normaliseSeries(points: number[], mode: "pct" | "max"): number[] {
  if (points.length === 0) return [];
  if (mode === "pct") {
    return points.map((v) => Math.max(0, Math.min(100, v)) / 100);
  }
  const max = Math.max(...points, 0);
  if (max <= 0) return points.map(() => 0);
  return points.map((v) => Math.max(0, v) / max);
}
